import { Typography, Descriptions, Tag, Button } from 'antd';
import { palette } from '@shipium-corp/shipium-ui-theme';
import { useNavigate } from 'react-router-dom-v5-compat';
import { formatInTimeZone } from 'date-fns-tz';
import type { Schedule } from '../../../store/services/FP_FulfillmentContextService/types';
import { formatAddressAsList } from '../utils';
import type { PartnerAddressV2, PartnerOrigin } from '@shipium-corp/shipium-ts-types';

const { Text } = Typography;

export interface FulfillmentContextOriginSummaryProps {
  origin: PartnerOrigin;
  address?: PartnerAddressV2;
  schedule?: Schedule | null;
  contextLink: string;
}

export const FulfillmentContextOriginSummary = ({
  origin,
  address,
  schedule,
  contextLink,
}: FulfillmentContextOriginSummaryProps) => {
  const allDays = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
  const navigate = useNavigate();
  const activeSchedule = schedule?.entries?.find(
    (s) => s.to >= new Date().toISOString() && s.from <= new Date().toISOString(),
  );
  const renderShippingDays = () => {
    if (activeSchedule?.shippingDays && Array.isArray(activeSchedule.shippingDays)) {
      const days = allDays.map((day) => {
        const isEnabled = (activeSchedule.shippingDays ?? []).find((shippingDay) => shippingDay.slice(0, 3) === day);
        return (
          <Tag key={`${origin.originId}-${day}`} color={isEnabled ? palette.Teal.light : undefined}>
            {day}
          </Tag>
        );
      });

      return <Descriptions.Item label="Shipping Days">{days}</Descriptions.Item>;
    } else {
      return <Text type="danger">No shipping days configured</Text>;
    }
  };

  return (
    <div key={origin.originId}>
      <Button
        type={'link'}
        size={'large'}
        style={{ height: 'auto', margin: 0, padding: 0, fontWeight: 'bold' }}
        onClick={() => navigate(contextLink)}
      >
        {origin.name}
      </Button>
      <Descriptions size={'small'} column={1} layout="vertical">
        <Descriptions.Item>{formatAddressAsList(address)}</Descriptions.Item>
        {renderShippingDays()}
        {address?.location?.validatedAddressMetadata?.timeZoneId && (
          <Descriptions.Item>
            <Tag>
              {formatInTimeZone(new Date(), address?.location?.validatedAddressMetadata?.timeZoneId, 'h:mm a zzz')}
            </Tag>
          </Descriptions.Item>
        )}
      </Descriptions>
    </div>
  );
};
